import React, { useEffect } from 'react';

import Axios from 'axios';

import styled from 'styled-components';

import { Loading } from '@components/Gui/Loading';

import EmailsFormWrapper from './EmailsFormWrapper';
import { buildEmailItems } from './emailUtils';
import EventsSelectionWrapper from './EventsSelectionWrapper';
import { useSendProjectDrawer } from './SendProjectDrawerContext';
import { SendProjectDrawerContainer } from './SendProjectDrawerUI';

/**
 * Styled component for loading overlay
 */
const LoadingContainer = styled.div`
    position: absolute;
    right: 0;
    left: 0;
    top: 40%;
    z-index: 2000;
`;

/**
 * Main SendProjectDrawerContent component
 * Manages the overall flow between event selection and email sending
 */
const SendProjectDrawerContent = ({ currentProject, ModelID, EventID, EventType, onClose }) => {
    const { state, actions, exportSelection } = useSendProjectDrawer();
    const { emailItems, isSending, isFetching } = state;

    /**
     * Initialize project data when component mounts or props change
     */
    useEffect(() => {
        actions.setProjectData({
            currentProject,
            ModelID,
            EventID,
            EventType,
        });
    }, [currentProject, ModelID, EventID, EventType]);

    /**
     * Generates document versions and builds email items
     */
    const onGenerateDocVersions = async () => {
        if (exportSelection) {
            // Only what is visible and switched on ends up in the e-mails
            const dataToSend = {
                ...exportSelection,
                ProjectID: currentProject.ID,
                Template: 'pmc2',
                Area: 'ProjectModelCalendar',
                OutputFileName: 'MailProjectModelCalendar',
            };

            actions.setSendingState(true);
            try {
                const emailsData = await Axios.post('/projects/generateModelCalendar', dataToSend);
                actions.setSendingState(false);

                const newEmailItems = buildEmailItems(emailsData, currentProject);
                actions.setEmailItems(newEmailItems);

                // Scroll to top of drawer
                document.querySelector('.ant-drawer-body').scrollTop = 0;
            } catch (error) {
                actions.setSendingState(false);
                actions.setErrorSending('Error generating document versions', error);
            }
        }
    };

    if (isFetching) {
        return <Loading />;
    }

    return (
        <>
            {isSending && (
                <LoadingContainer>
                    <Loading />
                </LoadingContainer>
            )}
            <SendProjectDrawerContainer isSending={isSending}>
                {emailItems ? (
                    <div className="emails-step">
                        <EmailsFormWrapper onClose={onClose} />
                    </div>
                ) : (
                    <EventsSelectionWrapper onClose={onClose} onGenerateDocVersions={onGenerateDocVersions} />
                )}
            </SendProjectDrawerContainer>
        </>
    );
};

export default SendProjectDrawerContent;
